/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/views/web/product/conponents/ProductFormDeatil/ProductDetailMmuFooter.tsx
 * @Description: 商品详情页操作按钮集合
 */
import { useContext, useState } from 'react';
import { CartContext, UserContext } from 'libs/contexts';
import { AgreementPriceMissingReason } from 'libs/enums';
import useUrl from 'hooks/useUrl';
import { Modal, message } from 'antd';
import useToLogin from '@/hooks/useToLogin';
import { addGoodsAnimate } from 'libs/animate';
import useAreaCookie from 'hooks/useAreaCookie';
import {
  useTradeModeContext,
  useTradeAgreementContext,
  useShopDataContext,
  useProductDetailContext,
  useNetPriceTypeContext,
} from 'views/web/product/context';
import { checkMmu, buildSku } from '../helper';
const ProductDetailMmuFooter = ({
  skuDetail,
  agreeAndUserTypeIsAvailable,
  shopQuantity,
  shopId,
  canShowEnquiryBtn,
  handleEnquiry,
}) => {
  const userInfo = useContext(UserContext);
  const { getCookieAreaSysNo } = useAreaCookie();
  const { selectTradeAgreement } = useTradeAgreementContext();
  const { selectTradeMode } = useTradeModeContext();
  const { selectNetPriceType } = useNetPriceTypeContext();
  const { shop } = useShopDataContext();
  const { getMmuSkuList } = useProductDetailContext();
  const { handleLogin } = useToLogin();
  const { addCart, refreshData } = useContext(CartContext);
  const [visible, setVisible] = useState(false);
  const noAgreementCanNotSale =
    !skuDetail.noAgreementCanSale && !skuDetail.tradeAgreementEntityList?.length;
  const skuForPriceCalculate = selectTradeAgreement?.skuForPriceCalculate?.[0] || {};
  const isTakeDown = skuDetail.status == 0;
  const { agreementCanSale } = skuDetail;
  const basePriceCanNotSale =
    skuDetail.salesPrice === null &&
    agreementCanSale &&
    skuForPriceCalculate.agreementPriceMissingReason ===
      AgreementPriceMissingReason.TRADE_AGREEMENT_PRICE_MISSING;

  // 是否可以下单(直接购买｜加入购物车)
  const isAllowTransactions =
    userInfo &&
    (!skuDetail.areaCanSale ||
      !(skuDetail.inventory || skuDetail.inventory == null) ||
      skuDetail.supplierLimitEnable ||
      basePriceCanNotSale ||
      !agreeAndUserTypeIsAvailable);

  // 创新专区商品不允许购买
  const isCXZQProduct = shopId === '1047548387118899707';

  const { getPublicUrl } = useUrl();

  const handleRequestPreCheck = () => {
    if (!userInfo) {
      setVisible(true);
      return false;
    }
    if (shopQuantity <= 0) {
      message.error('请输入采购数量！');
      return false;
    }
    return true;
  };

  const handleAdd = () => {
    if (!handleRequestPreCheck()) return;
    const sku = buildSku(skuDetail, shopQuantity);
    if (!sku) return;
    getMmuSkuList(sku);
  };
  // 加入购物车
  const handleAddShoppingCart = async (event) => {
    try {
      // 用户是否登录
      if (!handleRequestPreCheck()) return;
      if (!checkMmu(skuDetail.mmuAttributeList)) return;
      var json = {
        mallSkuSysNo: skuDetail.sysNo,
        quantity: shopQuantity,
        shopQuantity: shopQuantity,
        warehouseSysNo: skuDetail.warehouseSysNo,
        areaSysNo: getCookieAreaSysNo(),
        mmuAttributeList: skuDetail.mmuAttributeList,
        paymentSysNo: selectTradeMode.billingPeriod,
        billingPeriod: selectTradeMode.billingPeriod,
        accountPeriod: selectTradeMode.accountPeriod,
        paymentType: selectTradeMode.accountPeriod,
        agreementSysNo: selectTradeAgreement.sysNo,
        netPriceType: selectNetPriceType,
      };
      addCart(json, () => {
        addGoodsAnimate(
          event,
          getPublicUrl(skuDetail.mainImage),
          document.querySelector('.side-bar-icon'),
        );
        refreshData();
      });
    } catch (error) {}
  };
  // 直接购买
  const handleToBuy = async () => {
    // 用户是否登录
    if (!handleRequestPreCheck()) return;
    const params = {
      areaSysNo: getCookieAreaSysNo(),
      type: 0,
      mmuProductEnable: false,
      simulateSplitGroup: [
        {
          tradeAgreementSysNo: selectTradeAgreement.sysNo,
          shopSysNo: shop.sysNo,
          supplierSysNo: skuDetail.supplierSysNo,
          paymentType: selectTradeMode.accountPeriod,
          billingPeriod: selectTradeMode.billingPeriod,
          netPriceType: selectNetPriceType,
          skuType: skuDetail.skuType,
          skuList: [
            {
              mallSkuSysNo: skuDetail.sysNo,
              warehouseSysNo: skuDetail.warehouseSysNo,
              quantity: shopQuantity,
              shopQuantity: shopQuantity,
              mmuAttributeList: skuDetail.mmuAttributeList,
              priceFlag: skuDetail.priceFlag,
            },
          ],
        },
      ],
    };

    const form = document.getElementById('productDetaiMmuSubmitForm');
    const input = document.getElementById('productDetaiMmuSubmitData');
    input.value = JSON.stringify(params);
    form.submit();
  };

  const confirmModal = () => {
    handleLogin();
    setVisible(false);
  };
  return (
    <div>
      {!!skuDetail.useSkuList ? (
        <div className="pd-ft">
          <div>
            {noAgreementCanNotSale ? (
              <a
                className="btn btn-large btn-primary add-list-btn disabled"
                style={{ width: '320px' }}
              >
                <i className="iconfont icon-add" />
                暂无有效的交易规则，无法购买
              </a>
            ) : isTakeDown ? (
              <a className="btn btn-large btn-primary add-list-btn disabled">
                <i className="iconfont icon-add" />
                商品已下架
              </a>
            ) : !agreementCanSale ? (
              <a className="btn btn-large btn-primary add-list-btn disabled">
                <i className="iconfont icon-add" />
                不能使用此规则购买
              </a>
            ) : isAllowTransactions ? (
              <a className="btn btn-large btn-primary add-list-btn disabled">
                <i className="iconfont icon-add" />
                加入清单
              </a>
            ) : (
              <a className="btn btn-large btn-primary add-list-btn" onClick={handleAdd}>
                <i className="iconfont icon-add" />
                加入清单
              </a>
            )}
            {canShowEnquiryBtn && (
              <a className="btn btn-large btn-primary" onClick={handleEnquiry}>
                加入询价单
              </a>
            )}
          </div>
        </div>
      ) : (
        <div className="pd-ft">
          {noAgreementCanNotSale ? (
            <a className="btn btn-large disabled" style={{ width: '320px' }}>
              暂无有效的交易规则，无法购买
            </a>
          ) : isTakeDown ? (
            <a className="btn btn-large disabled">商品已下架</a>
          ) : !agreementCanSale ? (
            <a className="btn btn-large disabled">不能使用此规则购买</a>
          ) : isAllowTransactions || isCXZQProduct ? (
            <>
              <a className="btn btn-large btn-ghost disabled-ghost">直接购买</a>
              <a className="btn btn-large disabled">
                <i className="iconfont icon-shoppingCart" /> 加入购物车
              </a>
            </>
          ) : (
            <>
              <a className="btn btn-large btn-ghost btn-ghost-primary" onClick={handleToBuy}>
                直接购买
              </a>
              <a className="btn btn-large btn-primary" onClick={handleAddShoppingCart}>
                <i className="iconfont icon-shoppingCart" /> 加入购物车
              </a>
            </>
          )}
          {canShowEnquiryBtn && (
            <a className="btn btn-large btn-primary" onClick={handleEnquiry}>
              加入询价单
            </a>
          )}
          <form
            id="productDetaiMmuSubmitForm"
            action="/purchaser/trade/shopCreate"
            method="post"
            style={{ display: 'none' }}
          >
            <input id="productDetaiMmuSubmitData" name="data" hidden="hidden" />
          </form>
        </div>
      )}

      <Modal
        title="提示"
        width="400px"
        visible={visible}
        onOk={confirmModal}
        onCancel={() => setVisible(false)}
        okText="确认"
        cancelText="取消"
        maskClosable={false}
      >
        <p>请先完成登录，再继续操作！</p>
      </Modal>
      <style jsx>{`
        .btn-ghost {
            border: 1px solid #e8e8e8;
        }
        .btn-primary {
            color: #fff;
            background-color: var(--rv-primary-color);
        }
        .btn, .cascader-panel-item a, .tag {
            display: inline-block;
            vertical-align: top;
            padding: 0 0.5em;
            text-align: center;
            font-size: 12px;
            cursor: pointer;
        }
        .btn-ghost-primary {
            color: var(--rv-primary-color);
            background-color: #fff;
            border: 1px solid var(--rv-primary-color);
        }
        .btn-large {
            width: 180px;
            height: 48px;
            line-height: 48px;
            font-size: 16px!important;
            font-weight: 400;
            padding: 0!important;
        }
        .btn-large+.btn-large {
            margin-left: 20px;
        }
        .btn.disabled, .btn.disabled-ghost {
            cursor: not-allowed;
            pointer-events: none;
        }
        .btn.disabled {
            background-color: #d8d8d8!important;
            color: #fff!important;
        }
        .btn.disabled-ghost {
          background: #f9f9f9!important;
          border-color: #f1f1f1!important;
          color: #aaa!important;
        }
      `}</style>
    </div>
  );
};
export default ProductDetailMmuFooter;
